import createClient from "@bugsnag/js";
import reactPlugin from "@bugsnag/plugin-react";
import React, { ComponentType, FC } from "react";

export const client = process.env.REACT_APP_BUGSNAG_API_KEY
  ? createClient({
      apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
      appVersion: process.env.REACT_APP_VERSION,
      releaseStage: process.env.REACT_APP_ENVIRONMENT,
      filters: [/token/i, /password/i, /passphrase/i],
      collectUserIp: false,
    })
  : undefined;

export default client;

if (client) {
  client.use(reactPlugin, React);
}

const NoBoundary: FC = ({ children }) => <>{children}</>;

export const ErrorBoundary = client ? (client.getPlugin("react") as ComponentType) : NoBoundary;
